<script>
export default {
    name: "COATransactions",

    data() {

        return {
            coas: [],
            filter: {
                from: this.$moment().format(`YYYY-MM-DD`),
                to: this.$moment().format(`YYYY-MM-DD`),
                coaid: 0,
            },
            transactions: [],
        };
    },

    computed: {

        totalDebit() {
            if(!this.transactions.length) return 0;

            return this.transactions.map(trx => parseFloat(trx.debitAmount))
                .reduce((sum, debit) => sum+debit);
        },

        totalCredit() {
            if(!this.transactions.length) return 0;

            return this.transactions.map(trx => parseFloat(trx.creditAmount))
                .reduce((sum, cr) => sum+cr);
        },

        totalBal() {
            if(!this.transactions.length) return 0;

            return this.transactions.map(trx => parseFloat(trx.runningBalance))
                .reduce((sum, bal) => sum+bal);
        },
    },

    mounted() {
        this.$root.loading = true;
        Promise.all([ this.fetchCOAs(), this.fetchTransactions(), ]).then(() => {
            this.$root.loading = false;
        }).catch(() => { this.$root.loading = false; });
    },

    methods: {

        fetchCOAs() {
            let url = `Accounting/GetCOA`;

            return this.$http.get(url).then(({ data }) => {
                this.coas = data;
            }).catch(() => {});
        },

        fetchTransactions() {
            let url = `Accounting/GetCOATransactions`;
                url += `?AsFrom=${this.filter.from}`;
                url += `&AsTo=${this.filter.to}`;
                url += `&COAID=${this.filter.coaid}`;

            return this.$http.get(url).then(({ data }) => {
                this.transactions = data;
            }).catch(() => {});
        },

        printTransactions() {
            let url = `/finance-dashboard/coas/transactions/print`;
                url += `?coaid=${this.filter.coaid}`;
                url += `&from=${this.filter.from}`;
                url += `&to=${this.filter.to}`;

            window.open(url, `_blank`, `PrintTransactions`);
        },
    },
}
</script>
<template>
<div class="w-full flex flex-wrap">
    <div class="w-full flex flex-wrap items-center">
        <div class="md:w-1/4 w-full p-1">
            <label for="grid-coa" class="label-control">COA</label>
            <tail-select>
                <template v-slot:field>
                    <select v-model="filter.coaid" id="grid-coa" class="input-control input-sm text-xs">
                        <option :value="0">select COA</option>
                        <option v-for="coa in coas" 
                            :key="coa.coaid" :value="coa.coaid">{{ coa.name }}</option>
                    </select>
                </template>
            </tail-select>
        </div>
        <div class="md:w-1/4 w-full p-1">
            <label for="grid-date-from" class="label-control">From</label>
            <input type="date" v-model.trim="filter.from" 
                id="grid-date-from" class="input-control input-sm text-xs">
        </div>
        <div class="md:w-1/4 w-full p-1">
            <label for="grid-date-to" class="label-control">To</label>
            <input type="date" v-model.trim="filter.to" 
                id="grid-date-to" class="input-control input-sm text-xs">
        </div>
        <div class="md:w-1/4 w-full p-1">
            <button 
                @click.prevent="() => {
                    $root.loading = true;
                    fetchTransactions().then(() => {
                        $root.loading = false;
                    });
                }"
                class="btn-sm btn-primary text-xs rounded mt-4 mr-2">Filter</button>
            <button 
                @click.prevent="$root.exportToExcel(`coa-transactions`, `coa-transactions-table`)"
                class="btn-sm text-xs btn-info rounded mt-4 mr-2">
                Export
            </button>
            <button 
                @click.prevent="printTransactions"
                class="btn-sm text-xs btn-info rounded mt-4">
                Print
            </button>
        </div>
    </div>
    <div class="w-full overflow-auto" style="max-height:35rem;">
        <table class="table text-xs" id="coa-transactions-table">
            <thead class="bg-blue-500 text-white">
                <tr>
                    <th class="p-tiny">Id</th>
                    <th class="p-tiny">Date</th>
                    <th class="p-tiny">Account</th>
                    <th class="p-tiny">Memo</th>
                    <th class="p-tiny">Debit</th>
                    <th class="p-tiny">Credit</th>
                    <th class="p-tiny">Running Bal</th>
                </tr>
            </thead>
            <tbody class="bg-gray-100">
                <tr v-for="trx in transactions" :key="trx.ledgerID">
                    <td class="p-tiny">{{ trx.ledgerID }}</td>
                    <td class="p-tiny">{{ trx.date | dateFormat }}</td>
                    <td class="p-tiny">{{ trx.coaName }}</td>
                    <td class="p-tiny">{{ trx.memo }}</td>
                    <td class="p-tiny">{{ trx.debitAmount | numberFormat }}</td>
                    <td class="p-tiny">{{ trx.creditAmount | numberFormat }}</td>
                    <td class="p-tiny">{{ trx.runningBalance | numberFormat }}</td>
                </tr>
            </tbody>
            <tfoot class="bg-gray-300">
                <tr>
                    <th class="p-tiny text-right" colspan="4">Total</th>
                    <th class="p-tiny">{{ $formatCurrency(totalDebit) }}</th>
                    <th class="p-tiny">{{ $formatCurrency(totalCredit) }}</th>
                    <th class="p-tiny">{{ $formatCurrency(totalBal) }}</th>
                </tr>
            </tfoot>
        </table>
    </div>
</div>
</template>
